export interface McdSiteInfo {
  site: number;
  address: string;
  isMall: boolean;
}

// TEMPORARY: McD restaurant data (address, Mall flag) will eventually be imported
// from a spreadsheet into the backend and returned on the user object. Until that
// import exists, this hardcoded lookup (keyed by SITE, parsed from the employee's
// own pl-XXXXX@pl.mcd.com login email) stands in so the Dashboard and "Zgłoś
// Akcję" can be built and tested against both account types (normal vs Mall).
export const MCD_SITE_DIRECTORY: Record<number, McdSiteInfo> = {
  355: { site: 355, address: 'ul. Marszałkowska 104, 00-017 Warszawa', isMall: false },
  420: { site: 420, address: 'Galeria Mokotów, ul. Wołoska 12, 02-675 Warszawa', isMall: true },
};
